// extracted by mini-css-extract-plugin
module.exports = {"container":"DietsPageHeader_container__3xoWP"};